import React, { useCallback, useEffect } from 'react';

import { WizardCardList } from 'src/app/components/lib/wizard/card';

import { isOnlineDetailsStepValid } from '../../shared/helpers';
import { useDiscountWizardStateContext } from '../../state';
import { OnlineDetailsStepActions } from '../../state/online-details';

import { DetailsCard } from './details-card';
import { PreviewCard } from './preview-card';

import type { WizardStepComponentProps } from 'src/app/components/lib/wizard';

export function OnlineDetails({
  disableNextButton,
  enableNextButton,
  setComplete,
  setIncomplete,
  stepStatus,
}: WizardStepComponentProps) {
  const {
    configureStepState,
    onlineDetailsStepDispatch,
    onlineDetailsStepState: { onlineName, rank, visited },
    discountId,
    detailsStepState: { availableOnline },
  } = useDiscountWizardStateContext();

  const markStepComplete = useCallback(() => {
    enableNextButton();
    setComplete();
  }, [enableNextButton, setComplete]);

  const markStepIncomplete = useCallback(() => {
    disableNextButton();
    setIncomplete();
  }, [disableNextButton, setIncomplete]);

  useEffect(() => {
    const stepIsValid = isOnlineDetailsStepValid({ onlineName, rank, availableOnline });
    if (!stepIsValid && stepStatus.complete) {
      markStepIncomplete();
    }
    if (stepIsValid && !stepStatus.complete) {
      markStepComplete();
    }
  }, [availableOnline, markStepComplete, markStepIncomplete, onlineName, rank, stepStatus.complete]);

  useEffect(() => {
    if (!visited && discountId === 0) {
      onlineDetailsStepDispatch(
        {
          type: OnlineDetailsStepActions.SET_VISITED,
          payload: { defaultOnlineName: configureStepState.discountName },
        },
        true
      );
    }
  }, [configureStepState.discountName, discountId, onlineDetailsStepDispatch, visited]);

  return (
    <WizardCardList $maxWidth='850px'>
      <DetailsCard />
      <PreviewCard />
    </WizardCardList>
  );
}
